export abstract class UserProfileDisplayBaseDto {
    profileApproved: any;
    isInactive: boolean;

    get hasProfile(): boolean {
        return this.profileApproved === true || this.profileApproved === false;
    }

    get approvedProfile(): boolean {
        return this.profileApproved === true;
    }

    get notApprovedProfile(): boolean {
        return this.profileApproved === false;
    }

    get isSystemUser(): boolean {
        return this.getUserId().toLowerCase() === this.getDisplayName().toLowerCase();
    }

    abstract getUserId(): string;

    abstract getDisplayName(): string;
}
